<template>
  <div id="app" :style="{ width: '100%', height: '100%' }">
    <!-- <yn-header
      style="width: 100%"
      :user="user"
      @dropClick="dropClick"
      :placeHoldImg="placeHoldImg"
      :homeImg="homeImg"
    ></yn-header> -->
    <!-- <yn-menu
      style="width: 35vh"
      :menuList="menuList"
      :menuRoot="menuRoot"
    ></yn-menu>  -->

    <!-- <yn-teacher
      :value="selectTeaInfo"
      @input="selectUser"      
    ></yn-teacher>  -->

    <yn-upload
      ref="upload_file"
      accept="video"
      :value="uploadFiels"
      config="tyrz/thirdApp"
      max="2"
    ></yn-upload>
    <!-- <Button @click="upload">上传</Button>
    <Button @click="edit">编辑</Button> -->

    <!-- <yn-class :studySectionId="studySectionId"> </yn-class> -->

    <!-- <Button @click="studySectionId='043aacc2df534b8998644fd059d7c758'">更新</Button> 
    <yn-editor ></yn-editor>
    <Button @click="upload">显示</Button> 
     <yn-editor v-model="content"></yn-editor>  -->

    <yn-address
      :subdistrict="4"
      v-model="currentAddress"
      @selectAddress="selectInfo"
    ></yn-address>

    <yn-select2v
      v-model="showModel"
      @emit_check="emit_check"
      show_title="职位"
      type="Industry"
    ></yn-select2v>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentAddress: {
        province: "省",
        city: "市",
        district: "区",
        street: "镇",
      },
      showModel: "",
      multiple: true,
      content: "123",
      uploadFiels: {
        id: "b96569be48214df8ba04f6013dde2807",
        app: "统一认证管理系统",
        creator: "",
        createTime: "2021-01-20 11:24:25",
        businessType: "tyrz/thirdApp",
        uploadType: "Files",
        files: [
          // {
          //   o: {
          //     name: "王建军.jpg",
          //     suff: ".jpg",
          //     no: 0,
          //     fullPath:
          //       "http://139.224.206.148:20001/upload/tyrz/thirdApp/34982da4-fd2b-4a92-98fc-28724458e17b_O.jpg",
          //     uriPath: "http://139.224.206.148:20001",
          //     path:
          //       "/upload/tyrz/thirdApp/34982da4-fd2b-4a92-98fc-28724458e17b_O.jpg",
          //     length: 148628,
          //   },
          //   ts: [],
          //   status: "Uploaded",
          // },
          {
            o: {
              name: "1610599932903.jpg",
              suff: ".jpg",
              no: 1,
              fullPath:
                "http://139.224.206.148:20001/upload/tyrz/thirdApp/2640bc38-71ce-49d7-97c8-1e1ead49682b_O.jpg",
              uriPath: "http://139.224.206.148:20001",
              path:
                "/upload/tyrz/thirdApp/2640bc38-71ce-49d7-97c8-1e1ead49682b_O.jpg",
              length: 122140,
            },
            ts: [],
            status: "Uploaded",
          },
        ],
      },
      // uploadFiels: {
      //   filesCount: 0,
      //   id: null,
      //   files: [],
      // },
      // selectTeaInfo: {},
      // user: {
      //   name: "1223",
      // },
      placeHoldImg: 'this.src="' + require("./assets/logo.png") + '"',
      homeImg: require("./assets/logo.png"),
      // menuRoot: {
      //   name: "统一认证",
      //   icon: "http://139.224.206.148:21001/icon/icon-p-6.png",
      // },

      // studySectionId:''
    };
  },
  methods: {
    selectInfo(model) {
      console.log(JSON.stringify(model));
    },

    // dropClick(type) {
    //   console.log(type);
    // },
    // // test() {
    // //   this.$axios({
    // //     url: "test",
    // //     method: "GET",
    // //   }).then((res) => {});
    // // },
    // selectUser(userInfo) {
    //   console.log(JSON.stringify(userInfo));
    //   this.selectTeaInfo = userInfo;
    // },
    // edit() {

    // },
    // upload() {
    //   this.$refs.upload_file.upload().then((data) => {
    //     this.uploadFiels = data;

    //   });

    // },
    emit_check() {},

    // log(array) {
    //   var str = "";
    //   for(let i = 0; i< array.length; i ++) {
    //     var model = array[i];
    //     str += `new DicItem("${i<10 ? "0":""}${i+1}0000","${model.title}"),\n`;
    //     var children = model.children;
    //     for(let j = 0 ; j < children.length ;j ++) {
    //       var child = children[j];
    //       str += `new DicItem("${i<10 ? "0":""}${i+1}${j<10 ? "0":""}${100*(j+1)}","${child.title}"),\n`
    //     }
    //   }
    //   console.log(str);
    // }
  },
  created() {
    // this.log(this.profession_data);
    // localStorage.setItem(
    //   "token",
    //   "eyJhbGciOiJSUzI1NiIsImtpZCI6IjU5MDMxRjM5MTkwRUQ4NEZFMkUyRTJEN0I3QkQ2QTIwNjQ3RjM0RUEiLCJ0eXAiOiJhdCtqd3QiLCJ4NXQiOiJXUU1mT1JrTzJFX2k0dUxYdDcxcUlHUl9OT28ifQ.eyJuYmYiOjE2MTExMzE2MDIsImV4cCI6MTYxMTE2MDQwMiwiaXNzIjoiaWRlbnRpdHlzZXJ2ZXIiLCJhdWQiOiJ0eXJ6LmFwaSIsImNsaWVudF9pZCI6InR5cnoiLCJzdWIiOiJhZG1pbl95cyIsImF1dGhfdGltZSI6MTYxMTEzMTYwMiwiaWRwIjoibG9jYWwiLCJ1aWQiOiI0ZTFlZTZiMDg0NDQ0ODkyYjNjMmI5MTkyNTdiODIxYiIsIm5hbWUiOiLmvJTnpLrnrqHnkIblkZgiLCJ0eXBlIjoiYWRtaW5fc2NoIiwic2NoSWQiOiIzMDAxIiwic2NvcGUiOlsidHlyei5hcGkiXSwiYW1yIjpbInlhb25pbmciXX0.xi0jwgU2wjU0rPtrOGQeaMPABQz1OL37dRYIHjEzZ9rs7GfK_q8IDP9-MpbYdP5ru_Yeoy9Atrpz2pW_YIW3Nt8yrSgx2N2NnQ7CrTQoqBGupXHt0fJdLB7hQDcgJyAAngH9XJ3X3x8Z8_rcfshzhkcVe-l_uIb8uL7ptTrj35Cb_Edp0rZ4fWIYr_OYKWUADLv430sJnxBeCr8Ope4gUd09hmz6rrCDeTNHd9IAPHKUWwWydy4a20GUOhTUWmw6PKZYhIdk5w8_nEu6hUAZxPNQXbIXSkhIW7cWK8IjyU43pJhQVgH_a0aO9NSMig5PAtNaX_KAsPLO8mvYfnVJKQ"
    // );
    // this.test();
    // setTimeout(() => {
    //   this.currentAddress = {"province":"上海市","city":"上海城区","district":"崇明区","street":"堡镇"};
    // }, 2000);
  },
};
</script>
<style>
/* @import "assets/common.css"; */
</style>
